module.exports = __webpack_public_path__ + "default.04eeeba5b3538c4524d8e6828ba2c405.png";